module.exports = __webpack_public_path__ + "img/MADDEN23-banner_day2.af7090b7.png";